import React from "react";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { resetCart } from "../Auth/authActions";
import { HAButton } from "../utils/components/HAButton";
import { getIconByCategory, getRoute, sendGAEvent, sendMetaEvent } from "../utils/helper";
import useAppContext from "../utils/hooks/useAppContext";

const PaymentResult = ({ user, resetCart }) => {
  const { activeCategory } = useAppContext();
  const [status, setStatus] = React.useState(null);
  const [trackingId, setTrackingId] = React.useState("");
  const [message, setMessage] = React.useState("");

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const statusParam = params.get("status");
    const trackingIdParam = params.get("trackingId") || "";
    const messageParam = params.get("message") || "";

    setStatus(statusParam);
    setTrackingId(trackingIdParam);
    setMessage(decodeURIComponent(messageParam.replace(/\+/g, " ")));

    if (statusParam === "success") {
      sendGAEvent("event", "purchase", {
        transaction_id: trackingIdParam,
        currency: "TRY",
        value: user?.cart?.amountToBePaid,
        items: (user?.cart?.items || []).map((item) => ({
          item_id: item.id,
          item_name: item.title,
        })),
      });

      sendMetaEvent("track", "Purchase", {
        value: user?.cart?.amountToBePaid,
        currency: "TRY",
        content_ids: (user?.cart?.items || []).map((item) => item.id),
        content_type: "product",
      });

      resetCart();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status === null) return null;

  const isSuccess = status === "success";

  return (
    <div className="PaymentResult">
      <Helmet>
        <title>{isSuccess ? "Ödeme Tamamlandı" : "Ödeme Başarısız"}</title>
      </Helmet>
      <div className="container">
        <div className="row">
          <div className="col-12 d-flex flex-column align-items-center">
            {isSuccess ? (
              <>
                <img
                  src={
                    getIconByCategory({
                      iconMainKey: "payment-complete-icon",
                      className: "icon",
                    })?.["imageUrl"]
                  }
                  alt="Ödeme tamamlandı"
                />
                <p className="result-text success-text">
                  Ödemeniz başarıyla tamamlandı
                </p>
                {trackingId && (
                  <p className="tracking-id">Takip No: {trackingId}</p>
                )}
                <HAButton
                  type="pri"
                  action={getRoute("courses")
                    ?.link.replace(":slug?", "")
                    .replace(":category", activeCategory)}
                  isLink
                >
                  Eğitimlere Gözat
                </HAButton>
              </>
            ) : (
              <>
                <div className="error-icon">
                  <svg
                    width="80"
                    height="80"
                    viewBox="0 0 80 80"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="40" cy="40" r="40" fill="#FEE2E2" />
                    <path
                      d="M28 28L52 52M52 28L28 52"
                      stroke="#EF4444"
                      strokeWidth="4"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
                <p className="result-text error-text">Ödeme başarısız</p>
                {message && (
                  <p className="error-message">{message}</p>
                )}
                <HAButton
                  type="pri"
                  action={getRoute("payment")?.link}
                  isLink
                >
                  Tekrar Dene
                </HAButton>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  resetCart: () => dispatch(resetCart()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentResult);
